export const NewBadge = () => {
  return (
    <div className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-red-500">
      <span className="typo-caption1 font-bold text-white">N</span>
    </div>
  )
}
